import styles from './listingQuality.module.scss'

// Bands come from the server (ListingCompletenessScoring.GetScoreBand); do not re-derive them
// from the numeric score or the badge and the modal can disagree.
const bandClasses = {
  Excellent: styles.scoreExcellent,
  Good: styles.scoreGood,
  Fair: styles.scoreFair,
  Poor: styles.scorePoor,
  Critical: styles.scoreCritical,
}

export const getScoreBandClass = (scoreBand) => bandClasses[scoreBand] || styles.scoreUnknown
